import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
export const canAssignDomain = async _ref => {
  let httpClient = _ref.httpClient,
    msid = _ref.request.msid;
  const _ref2 = getPremiumEssentialsSafe() ?? {},
    panorama = _ref2.panorama;
  if (!msid) {
    return {
      canAssignDomain: false,
      externalViewer: false
    };
  }
  const _await$import$Domains = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
      httpClient
    }),
    getSite = _await$import$Domains.getSite;
  try {
    const _await$getSite = await getSite({
        msid
      }),
      allowedDomain = _await$getSite.allowedDomain,
      externalViewer = _await$getSite.externalViewer;
    return {
      canAssignDomain: Boolean(allowedDomain),
      externalViewer: Boolean(externalViewer)
    };
  } catch (error) {
    panorama == null || panorama.errorMonitor().reportError(error, {
      tags: {
        errorType: 'canAssignDomain'
      }
    });
    return {
      canAssignDomain: false,
      externalViewer: false
    };
  }
};
//# sourceMappingURL=canAssignDomain.js.map